import { Input } from "antd";
import { debounce } from "lodash";
import styled from "styled-components";
import { useMemo, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import List from "./list";
import { tabsTypes } from "../../../conig";

export const Style = styled.div`
  display: flex;
  gap: 15px;

  .table-cont {
    flex: 1;
    border-radius: 4px;

    &.no-data {
      padding: var(--size-lg); 

      .main-c {
        .icon  {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: var(--size);
          width: 43px;
          height: 43px;
          background: #D1E9FF;
          border: 8px solid #EFF8FF;
          border-radius: 100%;

          svg {
            width: 18x;
            height: 18px;
            color: var(--color-primary-60);
          }
        }
      }

      h2 {
        color: #101828;
        font-size: var(--size);
        font-weight: 500;
        margin-bottom: 4px;
        text-align: center;
      }
    }

    &.all {
      min-height: 366px;

      p {
        max-width: 239px;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: var(--size-lg);
      }

      .ant-btn  {
        border-radius: 8px;

        svg {
          margin-top: -4px;
        }
      }
    }

    .custom-input {
      border-radius: 4px;
      height: 40px;
      box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05) !important;
      border-color: #D0D5DD !important;
      color: #595959 !important;

      margin-bottom: 10px;

      svg {
        color: #9DA4AE;
      } 
    }
  }
`;

export default function Table({
  type = 'locations',
  value = [],
  t = (s) => s,
  section = tabsTypes.MONITORING,
  onChange,
}) {
  const [availableSearch, setAvailableSearch] = useState('');
  const [availableFilter, setAvailableFilter] = useState('');
  const [noAvailableData, setNoAvailableData] = useState(false);

  const availableOnSearch = useMemo(() => debounce(setAvailableFilter, 400), []);

  const onAdd = (v) => {
    onChange([...value, v]);
  }

  const onRemove = (id = '') => {
    onChange(value.filter((val) => val.id !== id));
  }

  return (
    <Style>
      {noAvailableData ? (
        <div className="table-cont no-data flex-c all">
          <div className="flex-c jus-c flex-1 main-c">
            <div className="icon flex-c jus-c">
              <SearchOutlined />
            </div>
            <h2>
              {t(type === 'locations' ?
                'No Location found' :
                'No Stakeholder found')}
            </h2>
          </div>
        </div>
      ) : (
        <div className="table-cont">
          <Input
            prefix={<SearchOutlined />}
            value={availableSearch}
            placeholder={t('Search')}
            onChange={(e) => {
              setAvailableSearch(e.target.value);
              availableOnSearch(e.target.value);
            }}
            className="custom-input"
          />
          <List
            items={value}
            subject={type}
            type="available"
            setNoData={setNoAvailableData}
            filter={availableFilter}
            section={section}
            onAdd={onAdd}
            onRemove={onRemove}
          />
        </div>
      )}
    </Style>
  );
}
